import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Checkbox,
    ListItemText,
    Box,
  } from "@mui/material";
  import { useState } from "react";
import notificationsApi from "../../api/notifications";

  const CustomNotificationDialog = ({ open, onClose }: { open: boolean, onClose: () => void }) => {
    const [title, setTitle] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [userType, setUserType] = useState<Array<string>>([]);

  
    const handleSendCustomNotification = async (title: string, message: string, userType: Array<string>) => {
      if (!title || !message) {
        alert("Please enter both title and message");
        return;
      }

      if (userType.length === 0) {
        alert("Please select at least one user type");
        return;
      }

      if (userType.includes("all")) {
        userType = ["active", "past", "non", "pending", "pendingWithCompleted", "notLoggedIn"];
      }

      // Close dialog immediately and reset form
      setTitle("");
      setMessage("");
      setUserType([]);
      onClose();

      // Start the API call in the background (don't await)
      notificationsApi.sendCustomNotification(title, message, userType)
        .then(response => {
          console.log("Notification sent successfully:", response);
        })
        .catch(error => {
          console.error("Error sending notification:", error);
          // Optionally show a toast notification here if you want
        });
    };
  
    const handleUserTypeChange = (event) => {
      const value = event.target.value as string[];
      if (value.includes("all")) {
        setUserType(["all"]);
      } else {
        setUserType(value.filter((v) => v !== "all"));
      }
    };
  
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 3,
            backgroundColor: "white",
            border: "1px solid #e2e8f0",
          }
        }}
      >
        <DialogTitle sx={{ 
          fontWeight: 600, 
          color: "#1e293b",
          pb: 1
        }}>
          Send Custom Notification
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f8fafc",
                  "&:hover": {
                    backgroundColor: "#f1f5f9",
                  },
                  "&.Mui-focused": {
                    backgroundColor: "white",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#64748b",
                },
                "& .MuiOutlinedInput-input": {
                  color: "#1e293b",
                },
              }}
            />
            <TextField
              label="Message"
              fullWidth
              multiline
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f8fafc",
                  "&:hover": {
                    backgroundColor: "#f1f5f9",
                  },
                  "&.Mui-focused": {
                    backgroundColor: "white",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#64748b",
                },
                "& .MuiOutlinedInput-input": {
                  color: "#1e293b",
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel sx={{ color: "#64748b" }}>User Type</InputLabel>
              <Select
                multiple
                value={userType}
                onChange={handleUserTypeChange}
                renderValue={(selected) => selected.join(", ")}
                sx={{
                  borderRadius: 2,
                  backgroundColor: "#f8fafc",
                  "&:hover": {
                    backgroundColor: "#f1f5f9",
                  },
                  "&.Mui-focused": {
                    backgroundColor: "white",
                  },
                  "& .MuiSelect-select": {
                    color: "#1e293b",
                  },
                }}
              >
                <MenuItem value="all">
                  <Checkbox 
                    checked={userType.includes("all")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="All Users" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="active">
                  <Checkbox 
                    checked={userType.includes("active")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Active Subscribers" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="past">
                  <Checkbox 
                    checked={userType.includes("past")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Past Subscribers" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="non">
                  <Checkbox 
                    checked={userType.includes("non")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Never Subscribed" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="pending">
                  <Checkbox 
                    checked={userType.includes("pending")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Pending Subscribers" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="pendingWithCompleted">
                  <Checkbox 
                    checked={userType.includes("pendingWithCompleted")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Pending With Completed" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                <MenuItem value="notLoggedIn">
                  <Checkbox 
                    checked={userType.includes("notLoggedIn")}
                    sx={{
                      color: "#0f172a",
                      "&.Mui-checked": {
                        color: "#0f172a",
                      },
                    }}
                  />
                  <ListItemText 
                    primary="Not Logged In" 
                    sx={{ "& .MuiTypography-root": { color: "#1e293b" } }}
                  />
                </MenuItem>
                </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button 
            onClick={onClose}
            sx={{
              color: "#64748b",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#f1f5f9",
              },
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={() => handleSendCustomNotification(title, message, userType)} 
            variant="contained"
            sx={{
              backgroundColor: "#0f172a",
              color: "white",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "#1e293b",
              },
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default CustomNotificationDialog;
  